import React from 'react';
import { parseMessageLinks } from '../../utils/linkParser';
import ClickableLink from './ClickableLink';

const MessageWithLinks = ({ message }) => {
    if (!message || typeof message !== 'string') {
        return <span>{ message }</span>;
    }

    const parts = parseMessageLinks(message);

    return (
        <span>
            { parts.map((part, index) => {
                if (part.type === 'link') {
                    return (
                        <ClickableLink
                            key={ index }
                            entityType={ part.entityType }
                            entityId={ part.entityId }
                            content={ part.content }
                        />
                    );
                } else {
                    return <span key={ index }>{ part.content }</span>;
                }
            }) }
        </span>
    );
};

export default MessageWithLinks;
